import React, { useContext } from 'react';

import Spinner from '@atlaskit/spinner';

import { DiffContext } from 'src/components/diff-set/diff-provider';
import { Loading } from 'src/sections/global/components/loading.style';
import { Diff } from 'src/types/pull-request';

type Props = {
  file: Diff;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const PartialDiff: React.FC<Props> = ({ file }) => {
  const { loadFileDiff } = useContext(DiffContext);
  loadFileDiff(file.from, file.to);

  // Once the load completes, this entire component will be replaced so we
  // don't need to worry about the actual file contents
  return (
    <Loading>
      <Spinner size="medium" testId="partial-diff-loading-spinner" />
    </Loading>
  );
};
